export default "__VITE_ASSET__BJb8u6Vx__"